const GOOGLE_SEARCH_BASE = 'https://www.google.com/search?q=';
const PROXY_PREFIX = 'https://r.jina.ai/http://';
const FETCH_TIMEOUT_MS = 7000;
const MAX_RESULT_PAGES = 7;

const STORE_CONFIG = [
  { id: 'robu', searchUrl: 'https://robu.in/?s=' },
  { id: 'robocraze', searchUrl: 'https://robocraze.com/search?q=' },
  { id: 'electronicscomp', searchUrl: 'https://www.electronicscomp.com/search?q=' },
  { id: 'amazon', searchUrl: 'https://www.amazon.in/s?k=' },
  { id: 'flipkart', searchUrl: 'https://www.flipkart.com/search?q=' },
  { id: 'thingbits', searchUrl: 'https://thingbits.net/search?q=' },
];

const COMPONENT_DB = [
  { id: 'esp32', terms: ['esp32', 'nodemcu'], name: 'ESP32 Dev Board', category: 'Microcontroller', specs: '3.3V logic, Wi-Fi + BLE', min: 280, max: 620, priority: 'essential' },
  { id: 'arduino_uno', terms: ['arduino uno', 'atmega328'], name: 'Arduino UNO R3', category: 'Microcontroller', specs: 'ATmega328P, 5V logic', min: 420, max: 900, priority: 'essential' },
  { id: 'raspberry_pi', terms: ['raspberry pi', 'rpi 4'], name: 'Raspberry Pi 4', category: 'Microcontroller', specs: 'SBC with 2GB/4GB RAM', min: 4200, max: 7800, priority: 'essential' },
  { id: 'dht22', terms: ['dht22', 'am2302'], name: 'DHT22 Sensor', category: 'Sensor', specs: 'Temperature and humidity sensor', min: 220, max: 520, priority: 'recommended' },
  { id: 'dht11', terms: ['dht11'], name: 'DHT11 Sensor', category: 'Sensor', specs: 'Entry-level temperature and humidity sensor', min: 90, max: 220, priority: 'recommended' },
  { id: 'bmp280', terms: ['bmp280', 'barometric'], name: 'BMP280 Sensor', category: 'Sensor', specs: 'Pressure and altitude sensor', min: 140, max: 360, priority: 'recommended' },
  { id: 'ultrasonic', terms: ['hc-sr04', 'ultrasonic sensor'], name: 'HC-SR04 Ultrasonic Sensor', category: 'Sensor', specs: '2cm to 400cm ranging', min: 70, max: 180, priority: 'recommended' },
  { id: 'pir', terms: ['pir sensor', 'motion sensor'], name: 'PIR Motion Sensor', category: 'Sensor', specs: '5V digital motion sensing', min: 80, max: 220, priority: 'essential' },
  { id: 'soil_moisture', terms: ['soil moisture'], name: 'Soil Moisture Sensor', category: 'Sensor', specs: 'Analog soil moisture sensing', min: 70, max: 250, priority: 'essential' },
  { id: 'relay', terms: ['relay module', '1 channel relay', 'relay board'], name: '1-Channel Relay Module', category: 'Actuator', specs: '5V trigger, 10A switching', min: 90, max: 260, priority: 'recommended' },
  { id: 'l298n', terms: ['l298n', 'motor driver'], name: 'L298N Motor Driver', category: 'Actuator', specs: 'Dual H-bridge motor driver', min: 180, max: 420, priority: 'essential' },
  { id: 'dc_motor', terms: ['dc gear motor', 'dc motor'], name: 'DC Gear Motor', category: 'Actuator', specs: '6V to 12V geared motor', min: 180, max: 460, priority: 'recommended' },
  { id: 'servo', terms: ['sg90', 'servo motor'], name: 'SG90 Servo Motor', category: 'Actuator', specs: '5V micro servo', min: 120, max: 280, priority: 'recommended' },
  { id: 'buzzer', terms: ['buzzer'], name: 'Active Buzzer Module', category: 'Actuator', specs: '3.3V/5V buzzer module', min: 40, max: 120, priority: 'recommended' },
  { id: 'oled', terms: ['0.96 oled', 'oled display'], name: '0.96 inch OLED Display', category: 'Display', specs: 'I2C 128x64 display', min: 160, max: 420, priority: 'optional' },
  { id: 'lcd', terms: ['16x2 lcd', 'lcd display'], name: '16x2 LCD Display', category: 'Display', specs: 'Character LCD with I2C backpack', min: 160, max: 420, priority: 'optional' },
  { id: 'buck', terms: ['lm2596', 'buck converter', 'step down module'], name: 'LM2596 Buck Converter', category: 'Power', specs: 'Adjustable DC-DC step-down', min: 90, max: 280, priority: 'recommended' },
  { id: 'battery', terms: ['18650', 'lipo battery', 'battery pack'], name: 'Rechargeable Battery Pack', category: 'Power', specs: 'Li-ion/LiPo pack depending on load', min: 300, max: 1500, priority: 'recommended' },
  { id: 'pump', terms: ['water pump', 'mini pump'], name: 'Mini Water Pump', category: 'Actuator', specs: '5V/12V submersible pump', min: 220, max: 650, priority: 'recommended' },
  { id: 'breadboard', terms: ['breadboard', 'solderless breadboard'], name: 'Solderless Breadboard', category: 'Passive', specs: '400 to 830 tie points', min: 90, max: 220, priority: 'recommended' },
  { id: 'jumper', terms: ['jumper wire', 'dupont wire'], name: 'Jumper Wire Set', category: 'Passive', specs: 'Male-male and male-female pack', min: 90, max: 260, priority: 'recommended' },
];

const SEARCH_CACHE = new Map();
const PAGE_CACHE = new Map();
const STORE_CACHE = new Map();
const GROQ_CACHE = new Map();

const COMPONENT_KEYWORDS = [
  'module', 'sensor', 'board', 'driver', 'controller', 'relay', 'regulator', 'converter',
  'transistor', 'resistor', 'capacitor', 'inductor', 'diode', 'mosfet', 'battery', 'charger',
  'display', 'oled', 'lcd', 'motor', 'servo', 'pump', 'encoder', 'buzzer', 'switch',
  'connector', 'breadboard', 'jumper', 'antenna', 'gps', 'imu', 'accelerometer', 'gyroscope',
  'microcontroller', 'arduino', 'esp32', 'esp8266', 'raspberry pi', 'stm32', 'l298n',
];

const NON_COMPONENT_HINTS = [
  'tutorial', 'overview', 'introduction', 'conclusion', 'copyright', 'privacy', 'terms',
  'share', 'subscribe', 'click here', 'learn more', 'read more', 'add to cart', 'wishlist',
  'delivery', 'shipping', 'review', 'rating', 'login', 'sign up',
];

function slugify(text) {
  return String(text || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

function inr(v) {
  return `INR ${Math.round(v)}`;
}

function range(min, max) {
  return `INR ${Math.round(min)} - INR ${Math.round(max)}`;
}

function parseAnyPrice(value) {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  const str = String(value || '');
  const match = str.match(/([0-9]{2,6}(?:,[0-9]{3})*(?:\.[0-9]{1,2})?)/);
  return match ? Number(String(match[1]).replace(/,/g, '')) : null;
}

function buildDatasheetUrl(componentName) {
  return `https://www.google.com/search?q=${encodeURIComponent(`${componentName} datasheet pdf`)}`;
}

function proxied(url) {
  return PROXY_PREFIX + url.replace(/^https?:\/\//, '');
}

async function fetchText(url, timeoutMs = FETCH_TIMEOUT_MS) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(url, { signal: controller.signal });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.text();
  } finally {
    clearTimeout(timer);
  }
}

function extractUrls(rawText) {
  const matches = rawText.match(/https?:\/\/[^\s)\]]+/g) || [];
  const blocked = ['google.com/search', 'webcache', 'youtube.com', 'facebook.com', 'instagram.com', 'r.jina.ai'];
  const clean = matches
    .map((u) => u.replace(/[),.;]+$/, ''))
    .filter((u) => !blocked.some((b) => u.includes(b)));
  const seen = new Set();
  const unique = [];
  for (const u of clean) {
    if (!seen.has(u)) {
      seen.add(u);
      unique.push(u);
    }
  }
  return unique.slice(0, MAX_RESULT_PAGES);
}

function countOccurrences(text, needle) {
  const escaped = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const m = text.match(new RegExp(escaped, 'gi'));
  return m ? m.length : 0;
}

function scoreComponentsFromText(text) {
  const lowered = text.toLowerCase();
  return COMPONENT_DB.map((comp) => {
    const score = comp.terms.reduce((sum, term) => sum + countOccurrences(lowered, term), 0);
    return { comp, score };
  }).filter((x) => x.score > 0);
}

function normalizeComponentName(raw) {
  return String(raw || '')
    .replace(/^[-\u2022*#>\d.)\s]+/, '')
    .replace(/\s+/g, ' ')
    .replace(/[|:,;]+$/g, '')
    .trim();
}

function looksLikeComponentName(name) {
  const n = String(name || '').trim();
  if (!n || n.length < 3 || n.length > 90) return false;
  const lower = n.toLowerCase();
  if (NON_COMPONENT_HINTS.some((hint) => lower.includes(hint))) return false;
  if (/^(project|system|step|part list|components?)$/i.test(n)) return false;

  const hasKeyword = COMPONENT_KEYWORDS.some((k) => lower.includes(k));
  const hasPartNumber = /\b([a-z]{1,4}-?\d{2,5}[a-z0-9-]*)\b/i.test(n);
  const hasValuePart = /\b(\d+(\.\d+)?\s?(v|a|w|ma|uf|nf|pf|ohm|k|mhz|ghz))\b/i.test(n);

  return hasKeyword || hasPartNumber || hasValuePart;
}

function extractComponentCandidatesFromText(text) {
  const lines = String(text || '')
    .split(/\r?\n/)
    .map((line) => normalizeComponentName(line))
    .filter(Boolean);

  const scoreMap = new Map();

  lines.forEach((line) => {
    const lower = line.toLowerCase();
    const isListish = /^(\d+[).\s]|[-*•])/.test(line) || lower.includes('component') || lower.includes('parts');
    if (!isListish && line.length > 60) return;

    const candidate = line
      .replace(/^components?\s*[:-]\s*/i, '')
      .replace(/^parts?\s*[:-]\s*/i, '')
      .replace(/\s+\([^)]*\)\s*$/, '')
      .trim();

    if (!looksLikeComponentName(candidate)) return;

    const key = slugify(candidate);
    const keywordHits = COMPONENT_KEYWORDS.reduce((sum, k) => sum + (lower.includes(k) ? 1 : 0), 0);
    const partBonus = /\b([a-z]{1,4}-?\d{2,5}[a-z0-9-]*)\b/i.test(candidate) ? 2 : 0;
    const score = 1 + keywordHits + partBonus;
    scoreMap.set(key, {
      id: key,
      name: candidate,
      score: (scoreMap.get(key)?.score || 0) + score,
    });
  });

  return [...scoreMap.values()].sort((a, b) => b.score - a.score);
}

const INTENT_PROFILES = [
  { id: 'weather', match: ['weather', 'temperature', 'humidity', 'climate'], title: 'Smart Weather Monitoring System', keys: ['esp32', 'dht22', 'bmp280', 'oled', 'buck'] },
  { id: 'robot', match: ['robot', 'line follower', 'obstacle', 'autonomous'], title: 'Autonomous Robot Prototype', keys: ['arduino_uno', 'ultrasonic', 'l298n', 'dc_motor', 'battery'] },
  { id: 'security', match: ['security', 'alarm', 'intruder', 'motion'], title: 'Home Security Alert System', keys: ['esp32', 'pir', 'buzzer', 'relay', 'oled'] },
  { id: 'irrigation', match: ['irrigation', 'plant', 'soil', 'farm'], title: 'Automated Irrigation Controller', keys: ['esp32', 'soil_moisture', 'relay', 'pump', 'battery'] },
  { id: 'home_auto', match: ['home automation', 'smart home', 'appliance'], title: 'Smart Home Automation Controller', keys: ['esp32', 'relay', 'pir', 'buzzer', 'buck'] },
  { id: 'energy', match: ['solar', 'energy monitor', 'power monitoring', 'smart meter'], title: 'Energy Monitoring System', keys: ['esp32', 'oled', 'buck', 'relay'] },
  { id: 'tracking', match: ['gps', 'tracker', 'tracking', 'vehicle'], title: 'GPS Tracking Device', keys: ['esp32', 'battery', 'oled', 'buck'] },
  { id: 'health', match: ['health', 'pulse', 'spo2', 'heart rate', 'medical'], title: 'Health Monitoring Device', keys: ['esp32', 'oled', 'battery'] },
];

function detectIntent(prompt) {
  const p = prompt.toLowerCase();
  let best = null;
  let bestScore = 0;
  INTENT_PROFILES.forEach((profile) => {
    const score = profile.match.reduce((n, token) => n + (p.includes(token) ? 1 : 0), 0);
    if (score > bestScore) {
      bestScore = score;
      best = profile;
    }
  });
  return best;
}

function pickProjectTitle(prompt) {
  const intent = detectIntent(prompt);
  if (intent) return intent.title;
  return `Custom Project: ${prompt.slice(0, 40)}`;
}

function estimateDifficulty(prompt, count) {
  const p = prompt.toLowerCase();
  if (p.includes('robot') || p.includes('drone') || count >= 9) return 'Advanced';
  if (count >= 6) return 'Intermediate';
  return 'Beginner';
}

function estimateTime(difficulty) {
  if (difficulty === 'Advanced') return '2-5 days';
  if (difficulty === 'Intermediate') return '8-16 hours';
  return '3-6 hours';
}

function extractPrices(text) {
  const rx = /(?:₹|rs\.?|inr)\s*([0-9]{2,6}(?:,[0-9]{3})*(?:\.[0-9]{1,2})?)/gi;
  const arr = [];
  let m = rx.exec(text);
  while (m) {
    arr.push(Number(String(m[1]).replace(/,/g, '')));
    m = rx.exec(text);
  }
  return arr.filter((x) => Number.isFinite(x) && x > 0);
}

async function getGoogleResultPages(prompt) {
  const query = `${prompt} electronics components bill of materials`;
  if (SEARCH_CACHE.has(query)) return SEARCH_CACHE.get(query);

  try {
    const googleUrl = GOOGLE_SEARCH_BASE + encodeURIComponent(query);
    const text = await fetchText(proxied(googleUrl));
    const urls = extractUrls(text);
    SEARCH_CACHE.set(query, urls);
    return urls;
  } catch {
    return [];
  }
}

async function fetchPageEvidence(url) {
  if (PAGE_CACHE.has(url)) return PAGE_CACHE.get(url);
  try {
    const text = await fetchText(proxied(url), 6000);
    PAGE_CACHE.set(url, text);
    return text;
  } catch {
    PAGE_CACHE.set(url, '');
    return '';
  }
}

async function inferComponentsFromGoogle(prompt) {
  const urls = await getGoogleResultPages(prompt);
  const pages = await Promise.all(urls.map((u) => fetchPageEvidence(u)));
  const scoreMap = new Map();
  const webCandidatesMap = new Map();

  pages.forEach((pageText) => {
    extractComponentCandidatesFromText(pageText).forEach((item) => {
      const existing = webCandidatesMap.get(item.id);
      webCandidatesMap.set(item.id, {
        ...item,
        score: (existing?.score || 0) + item.score,
      });
    });

    scoreComponentsFromText(pageText).forEach(({ comp, score }) => {
      scoreMap.set(comp.id, (scoreMap.get(comp.id) || 0) + score);
    });
  });

  const dbSorted = [...scoreMap.entries()]
    .sort((a, b) => b[1] - a[1])
    .map(([id, score]) => ({ item: COMPONENT_DB.find((c) => c.id === id), score }))
    .filter((x) => x.item);

  const webSorted = [...webCandidatesMap.values()]
    .sort((a, b) => b.score - a.score)
    .slice(0, 12)
    .map((c) => ({ id: c.id, name: c.name, source: 'web', score: c.score }));

  const picked = [...webSorted, ...dbSorted.slice(0, 6).map((x) => x.item)];
  if (!picked.length) {
    const p = prompt.toLowerCase();
    return COMPONENT_DB.filter((c) => c.terms.some((t) => p.includes(t))).slice(0, 8);
  }
  return picked;
}

function inferComponentsFromPrompt(prompt) {
  const p = prompt.toLowerCase();
  const direct = COMPONENT_DB.filter((c) => c.terms.some((t) => p.includes(t))).slice(0, 10);
  const intent = detectIntent(prompt);
  const intentItems = intent
    ? COMPONENT_DB.filter((c) => intent.keys.includes(c.id))
    : [];

  const merged = [];
  const seen = new Set();
  [...direct, ...intentItems].forEach((item) => {
    if (item && !seen.has(item.id)) {
      seen.add(item.id);
      merged.push(item);
    }
  });

  if (merged.length) return merged.slice(0, 10);
  return COMPONENT_DB.filter((c) => ['esp32', 'dht11', 'oled', 'buck'].includes(c.id));
}

async function scrapeStoreEstimate(store, query, fallbackMin, fallbackMax) {
  const key = `${store.id}::${query}`;
  if (STORE_CACHE.has(key)) return STORE_CACHE.get(key);

  const fallback = {
    storeId: store.id,
    searchQuery: query,
    estimatedPrice: inr((fallbackMin + fallbackMax) / 2),
    priceValue: Math.round((fallbackMin + fallbackMax) / 2),
    availability: 'medium',
    notes: 'Fallback estimate (store scrape unavailable).',
  };

  try {
    const searchPage = store.searchUrl + encodeURIComponent(query);
    const text = (await fetchText(proxied(searchPage), 5000)).toLowerCase();
    const prices = extractPrices(text);
    const median = prices.length ? prices.sort((a, b) => a - b)[Math.floor(prices.length / 2)] : null;
    const mentions = query
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean)
      .reduce((n, token) => n + (text.includes(token) ? 1 : 0), 0);

    const result = {
      storeId: store.id,
      searchQuery: query,
      estimatedPrice: median ? inr(median) : fallback.estimatedPrice,
      priceValue: median || fallback.priceValue,
      availability: prices.length > 2 || mentions > 2 ? 'high' : prices.length ? 'medium' : 'low',
      notes: prices.length ? 'Live estimate from store search results.' : fallback.notes,
    };
    STORE_CACHE.set(key, result);
    return result;
  } catch {
    STORE_CACHE.set(key, fallback);
    return fallback;
  }
}

async function buildComponent(component, prompt) {
  const isDbComponent = Object.prototype.hasOwnProperty.call(component, 'terms');
  const dynamicMeta = inferCategoryFromName(component.name || component.id || '');
  const min = isDbComponent ? component.min : dynamicMeta.min;
  const max = isDbComponent ? component.max : dynamicMeta.max;
  const category = isDbComponent ? component.category : dynamicMeta.category;
  const priority = isDbComponent ? component.priority : dynamicMeta.priority;
  const specs = isDbComponent ? component.specs : dynamicMeta.specs || 'Verify exact package/spec from store listing.';

  const stores = await Promise.all(
    STORE_CONFIG.map((s) => scrapeStoreEstimate(s, component.name, min, max))
  );

  const desc =
    category === 'Microcontroller'
      ? 'Main controller that executes project logic and coordinates I/O.'
      : category === 'Sensor'
      ? 'Collects measurement/input data needed by this project.'
      : category === 'Actuator'
      ? 'Drives physical output or switching behavior.'
      : category === 'Power'
      ? 'Maintains stable power regulation and distribution.'
      : category === 'Display'
      ? 'Shows runtime values and project status.'
      : `Included based on evidence from web results for "${prompt.slice(0, 30)}...".`;

  return {
    id: slugify(component.id || component.name),
    name: component.name,
    category,
    quantity: 1,
    description: desc,
    specifications: specs,
    estimatedPrice: range(min, max),
    datasheetUrl: buildDatasheetUrl(component.name),
    priority,
    stores,
  };
}

async function inferComponentsFromGroq(prompt) {
  const key = String(prompt || '').trim().toLowerCase();
  if (!key) return [];
  if (GROQ_CACHE.has(key)) return GROQ_CACHE.get(key);

  try {
    const res = await fetch('/api/groq-components', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mode: 'bom', prompt }),
    });
    if (!res.ok) {
      GROQ_CACHE.set(key, []);
      return [];
    }
    const data = await res.json();
    const mapped = (Array.isArray(data?.components) ? data.components : [])
      .map((item) => ({
        id: slugify(item.name),
        name: String(item.name || '').trim(),
        category: String(item.category || 'Other').trim(),
        priority: ['essential', 'recommended', 'optional'].includes(String(item.priority || '').toLowerCase())
          ? String(item.priority).toLowerCase()
          : 'recommended',
        source: 'groq',
      }))
      .filter((x) => x.name);
    GROQ_CACHE.set(key, mapped);
    return mapped;
  } catch {
    GROQ_CACHE.set(key, []);
    return [];
  }
}

function tokenizeBomLine(line) {
  const csv = line.match(/("([^"]|"")*"|[^,]+)/g);
  if (csv && csv.length > 1) {
    return csv.map((x) => x.replace(/^"|"$/g, '').replace(/""/g, '"').trim());
  }
  return line
    .split(/\t|;|\|/)
    .map((x) => x.trim())
    .filter(Boolean);
}

function truthyCsvFlag(value) {
  const v = String(value || '').trim().toLowerCase();
  return ['1', 'true', 'yes', 'y', 'dnp', 'exclude', 'x'].includes(v);
}

function sanitizePartValue(value) {
  return String(value || '')
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function parseRefPrefix(referenceText) {
  const firstRef = String(referenceText || '')
    .split(',')
    .map((x) => x.trim())
    .filter(Boolean)[0] || '';
  const m = firstRef.match(/^([A-Za-z]+)/);
  return (m ? m[1] : '').toUpperCase();
}

function inferTypeFromRefPrefix(prefix) {
  const map = {
    C: 'Capacitor',
    R: 'Resistor',
    RV: 'Potentiometer',
    L: 'Inductor',
    D: 'Diode',
    Q: 'Transistor',
    U: 'IC',
    J: 'Connector',
    Y: 'Crystal',
    F: 'Fuse',
    K: 'Relay',
    SW: 'Switch',
  };
  return map[prefix] || null;
}

function buildNameFromBomFields({ reference, value, partName }) {
  const prefix = parseRefPrefix(reference);
  const inferredType = inferTypeFromRefPrefix(prefix);
  const cleanValue = sanitizePartValue(value);
  const cleanPart = sanitizePartValue(partName);

  if (cleanPart && cleanPart.length > 1 && !/^~+$/.test(cleanPart)) {
    return cleanPart;
  }

  if (!cleanValue || cleanValue === '~') {
    return inferredType ? `${inferredType}` : 'Electronic Component';
  }

  const upper = cleanValue.toUpperCase();
  if (upper.startsWith('CONN') || upper.includes('PINHEADER') || upper.includes('SOCKET')) {
    return 'Connector';
  }
  if (upper === 'LED') {
    return 'LED';
  }
  if (inferredType && !['R', 'C', 'L', 'D', 'U', 'J', 'Q', 'Y'].includes(upper)) {
    return `${inferredType} ${cleanValue}`;
  }
  if (inferredType) {
    return inferredType;
  }
  return cleanValue;
}

export function parseBomText(rawText) {
  const lines = String(rawText || '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .filter((line) => !line.startsWith('#') && !line.startsWith('//'));

  const entries = [];
  const knownHeader = [
    'component',
    'part',
    'item',
    'name',
    'description',
    'qty',
    'quantity',
    'value',
    'reference',
    'ref',
    'footprint',
    'datasheet',
  ];
  let headerMap = null;

  lines.forEach((line) => {
    const cols = tokenizeBomLine(line);
    if (!cols.length) return;

    const lowered = cols.map((c) => c.toLowerCase());
    const looksHeader = lowered.some((c) => knownHeader.some((h) => c.includes(h)));
    if (looksHeader && !headerMap) {
      headerMap = {
        reference: lowered.findIndex((c) => c === 'reference' || c === 'ref' || c.includes('reference')),
        quantity: lowered.findIndex((c) => c === 'qty' || c === 'quantity' || c.includes('qty') || c.includes('quantity')),
        value: lowered.findIndex((c) => c === 'value' || c.includes('value')),
        partName: lowered.findIndex((c) => c === 'component' || c === 'part' || c === 'name' || c.includes('component') || c.includes('part')),
        specs: lowered.findIndex((c) => c === 'footprint' || c.includes('footprint') || c.includes('package')),
        datasheet: lowered.findIndex((c) => c === 'datasheet' || c.includes('datasheet')),
        dnp: lowered.findIndex((c) => c === 'dnp' || c.includes('dnp')),
        excludeBom: lowered.findIndex((c) => c.includes('exclude from bom') || c === 'exclude'),
      };
      return;
    }

    if (cols.length === 1) {
      const only = cols[0];
      const match = only.match(/^(.+?)\s*(?:x|qty[:\s])\s*([0-9]+)$/i);
      if (match) {
        entries.push({
          name: match[1].trim(),
          quantity: Number(match[2]) || 1,
          specifications: '',
        });
      } else {
        entries.push({ name: only, quantity: 1, specifications: '' });
      }
      return;
    }

    const reference = headerMap?.reference >= 0 ? cols[headerMap.reference] : '';
    const qtyCell = headerMap?.quantity >= 0 ? cols[headerMap.quantity] : cols[1];
    const valueCell = headerMap?.value >= 0 ? cols[headerMap.value] : cols[0];
    const partCell = headerMap?.partName >= 0 ? cols[headerMap.partName] : '';
    const specsCell = headerMap?.specs >= 0 ? cols[headerMap.specs] : cols[2];
    const datasheetCell = headerMap?.datasheet >= 0 ? cols[headerMap.datasheet] : '';
    const dnpCell = headerMap?.dnp >= 0 ? cols[headerMap.dnp] : '';
    const excludeBomCell = headerMap?.excludeBom >= 0 ? cols[headerMap.excludeBom] : '';

    if (truthyCsvFlag(dnpCell) || truthyCsvFlag(excludeBomCell)) {
      return;
    }

    const refCount = String(reference || '')
      .split(',')
      .map((x) => x.trim())
      .filter(Boolean).length;
    const qty = Number.parseInt(String(qtyCell || '').replace(/[^\d]/g, ''), 10);
    const resolvedQty = Number.isFinite(qty) && qty > 0 ? qty : refCount || 1;
    const resolvedName = buildNameFromBomFields({
      reference,
      value: valueCell,
      partName: partCell,
    });
    entries.push({
      name: resolvedName,
      value: sanitizePartValue(valueCell),
      quantity: resolvedQty,
      reference: String(reference || '').trim(),
      specifications: String(specsCell || '').trim(),
      datasheetUrl:
        datasheetCell && /^https?:\/\//i.test(String(datasheetCell).trim())
          ? String(datasheetCell).trim()
          : '',
    });
  });

  return entries.filter((e) => e.name);
}

function inferCategoryFromName(name) {
  const lowered = String(name || '').toLowerCase();
  const direct = COMPONENT_DB.find((item) =>
    item.terms.some((term) => lowered.includes(term)) || lowered.includes(item.name.toLowerCase())
  );
  if (direct) {
    return { category: direct.category, priority: direct.priority, min: direct.min, max: direct.max, specs: direct.specs };
  }
  if (/(esp|arduino|raspberry|stm32|microcontroller|mcu)/i.test(lowered)) return { category: 'Microcontroller', priority: 'essential', min: 200, max: 1200, specs: '' };
  if (/(sensor|dht|bmp|pir|ultrasonic|ir)/i.test(lowered)) return { category: 'Sensor', priority: 'recommended', min: 80, max: 600, specs: '' };
  if (/(motor|relay|servo|driver|buzzer|pump)/i.test(lowered)) return { category: 'Actuator', priority: 'recommended', min: 120, max: 900, specs: '' };
  if (/(oled|lcd|display|screen)/i.test(lowered)) return { category: 'Display', priority: 'optional', min: 120, max: 700, specs: '' };
  if (/(buck|battery|power|adapter|supply)/i.test(lowered)) return { category: 'Power', priority: 'recommended', min: 120, max: 1200, specs: '' };
  if (/(wire|resistor|capacitor|breadboard|connector|module|pcb)/i.test(lowered)) return { category: 'Passive', priority: 'recommended', min: 40, max: 300, specs: '' };
  return { category: 'Other', priority: 'optional', min: 100, max: 600, specs: '' };
}

function normalizeBomName(name) {
  return String(name || '')
    .replace(/\s+/g, ' ')
    .replace(/[^\w\s\-+.()/]/g, '')
    .trim();
}

async function buildComponentFromBom(entry) {
  const cleanName = normalizeBomName(entry.name);
  const inferred = inferCategoryFromName(cleanName);
  const quantity = Number(entry.quantity) > 0 ? Number(entry.quantity) : 1;
  const stores = await Promise.all(
    STORE_CONFIG.map((s) => scrapeStoreEstimate(s, cleanName, inferred.min, inferred.max))
  );
  const prices = stores
    .map((s) => s.priceValue || parseAnyPrice(s.estimatedPrice))
    .filter((v) => Number.isFinite(v));
  const minPrice = prices.length ? Math.min(...prices) : inferred.min;
  const maxPrice = prices.length ? Math.max(...prices) : inferred.max;

  return {
    id: slugify(cleanName),
    name: cleanName,
    category: inferred.category,
    quantity,
    description: 'Imported from your BOM file with live store-wise comparisons.',
    specifications: [entry.value, entry.specifications || inferred.specs || ''].filter(Boolean).join(' | '),
    estimatedPrice: range(minPrice * quantity, maxPrice * quantity),
    priority: inferred.priority,
    datasheetUrl: entry.datasheetUrl || buildDatasheetUrl(cleanName),
    stores,
  };
}

export async function getComponentListFromBom(rawBom, fileName = 'BOM Upload') {
  const entries = parseBomText(rawBom);
  if (!entries.length) {
    throw new Error('No BOM rows found. Use CSV/TXT with component name, qty, and optional specs.');
  }

  const uniqueMap = new Map();
  entries.forEach((entry) => {
    const key = normalizeBomName(entry.name).toLowerCase();
    if (!key) return;
    const existing = uniqueMap.get(key);
    if (existing) {
      existing.quantity += Number(entry.quantity) || 1;
      if (!existing.specifications && entry.specifications) {
        existing.specifications = entry.specifications;
      }
      return;
    }
    uniqueMap.set(key, {
      name: normalizeBomName(entry.name),
      quantity: Number(entry.quantity) || 1,
      specifications: entry.specifications || '',
    });
  });

  const mergedEntries = [...uniqueMap.values()];
  const components = await Promise.all(mergedEntries.map((entry) => buildComponentFromBom(entry)));
  const totals = components.reduce(
    (acc, c) => {
      const matches = [...String(c.estimatedPrice).matchAll(/INR\s+(\d+)/g)].map((m) => Number(m[1]));
      if (matches.length >= 2) {
        return { min: acc.min + matches[0], max: acc.max + matches[1] };
      }
      if (matches.length === 1) {
        return { min: acc.min + matches[0], max: acc.max + matches[0] };
      }
      return acc;
    },
    { min: 0, max: 0 }
  );

  const complexity = mergedEntries.length > 20 ? 'Advanced' : mergedEntries.length > 10 ? 'Intermediate' : 'Beginner';
  return {
    project: {
      title: `BOM Import: ${String(fileName).replace(/\.[^.]+$/, '')}`,
      description: `Generated from uploaded BOM file with store-wise price comparison and ordering links.`,
      difficulty: complexity,
      estimatedCost: range(totals.min, totals.max),
      estimatedTime: complexity === 'Advanced' ? '2-4 hours' : complexity === 'Intermediate' ? '1-2 hours' : '30-60 mins',
    },
    components,
    tools: ['Multimeter', 'Soldering iron', 'Screwdriver set'],
    tips: [
      'Select your preferred store for each component to build a shop-wise checkout list.',
      'Use datasheet links to verify package type, voltage limits, and pinout.',
      'Prices are scraped estimates and may vary by SKU or stock status.',
    ],
    warnings: [
      'Always verify exact part number before ordering.',
      'Bulk discount and shipping costs are not included in this estimate.',
    ],
  };
}

export async function getComponentList(userPrompt) {
  const prompt = String(userPrompt || '').trim();
  if (!prompt) throw new Error('Please describe your project first.');

  try {
    const fromGroq = await inferComponentsFromGroq(prompt);
    const fromGoogle = await inferComponentsFromGoogle(prompt);
    const fromPrompt = inferComponentsFromPrompt(prompt);
    const intent = detectIntent(prompt);
    const intentItems = intent ? COMPONENT_DB.filter((c) => intent.keys.includes(c.id)) : [];

    const inferred = [];
    const seenInfer = new Set();
    [...fromGroq, ...fromGoogle, ...fromPrompt, ...intentItems].forEach((item) => {
      const key = item?.id || slugify(item?.name);
      if (item && key && !seenInfer.has(key)) {
        seenInfer.add(key);
        inferred.push(item);
      }
    });
    const dedup = [];
    const seen = new Set();
    inferred.forEach((c) => {
      if (!seen.has(c.id)) {
        seen.add(c.id);
        dedup.push(c);
      }
    });

    // Only add prototyping essentials if at least one controller is present.
    const hasController = dedup.some((c) => c.category === 'Microcontroller');
    if (hasController) {
      const essentials = intent?.id === 'robot' ? ['jumper'] : ['breadboard', 'jumper'];
      essentials.forEach((id) => {
        const item = COMPONENT_DB.find((c) => c.id === id);
        if (item && !seen.has(id)) {
          seen.add(id);
          dedup.push(item);
        }
      });
    }

    const varied = dedup.slice(0, 12);
    const components = await Promise.all(varied.map((c) => buildComponent(c, prompt)));
    const fallbackPromptComponents = await Promise.all(inferComponentsFromPrompt(prompt).map((c) => buildComponent(c, prompt)));
    const finalComponents = components.length ? components : fallbackPromptComponents;

    if (!finalComponents.length) {
      throw new Error('No inferred components');
    }

    const totals = finalComponents.reduce(
      (acc, c) => {
        const m1 = String(c.estimatedPrice || '').match(/INR\s+(\d+)/);
        const m2 = String(c.estimatedPrice || '').match(/-\s+INR\s+(\d+)/);
        return {
          min: acc.min + (m1 ? Number(m1[1]) : 0),
          max: acc.max + (m2 ? Number(m2[1]) : m1 ? Number(m1[1]) : 0),
        };
      },
      { min: 0, max: 0 }
    );
    const difficulty = estimateDifficulty(prompt, finalComponents.length);

    return {
      project: {
        title: pickProjectTitle(prompt),
        description: `Component list derived from web evidence and prompt intent for: "${prompt}".`,
        difficulty,
        estimatedCost: range(totals.min, totals.max),
        estimatedTime: estimateTime(difficulty),
      },
      components: finalComponents,
      tools: ['Soldering iron', 'Multimeter', 'Wire stripper', 'Screwdriver set'],
      tips: [
        'This list is generated from project intent plus live web/store signals when available.',
        'Mention exact voltage/current, budget, and performance constraints for more precise parts.',
        'Use store picker in each card to optimize total checkout cost.',
      ],
      warnings: [
        'Some pages block scraping; fallback estimates are used in those cases.',
        'Always verify exact SKU/part numbers on store pages before ordering.',
      ],
    };
  } catch {
    const emergency = inferComponentsFromPrompt(prompt).slice(0, 8);
    const components = await Promise.all(emergency.map((c) => buildComponent(c, prompt)));
    const difficulty = estimateDifficulty(prompt, components.length);
    const totals = components.reduce(
      (acc, c) => {
        const m1 = String(c.estimatedPrice || '').match(/INR\s+(\d+)/);
        const m2 = String(c.estimatedPrice || '').match(/-\s+INR\s+(\d+)/);
        return {
          min: acc.min + (m1 ? Number(m1[1]) : 0),
          max: acc.max + (m2 ? Number(m2[1]) : m1 ? Number(m1[1]) : 0),
        };
      },
      { min: 0, max: 0 }
    );

    return {
      project: {
        title: pickProjectTitle(prompt),
        description: `Offline-safe component recommendation for: "${prompt}".`,
        difficulty,
        estimatedCost: range(totals.min, totals.max),
        estimatedTime: estimateTime(difficulty),
      },
      components,
      tools: ['Soldering iron', 'Multimeter', 'Wire stripper', 'Screwdriver set'],
      tips: [
        'Web evidence was temporarily unavailable, so this run used local AI inference.',
        'Try again with a more detailed prompt to improve accuracy.',
      ],
      warnings: [
        'Verify exact model variants and package type before placing order.',
      ],
    };
  }
}

export async function askFollowUp(history, newMessage) {
  const msg = String(newMessage || '').trim();
  if (!msg) return 'Please ask a follow-up question.';

  try {
    const res = await fetch('/api/groq-components', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        mode: 'chat',
        prompt: msg,
        history: Array.isArray(history) ? history.slice(-10) : [],
      }),
    });

    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }

    const data = await res.json();
    const reply = String(data?.reply || '').trim();
    return reply || 'I could not generate a reply right now. Please try again.';
  } catch {
    const lowered = msg.toLowerCase();
    if (lowered.includes('add') || lowered.includes('modify') || lowered.includes('change')) {
      return 'UPDATE_NEEDED: Share the new requirement and regenerate to refresh the project component list.';
    }
    if (lowered.includes('wiring')) {
      return 'Wire power rails first, then controller, then sensors, and finally actuators. Test one block at a time.';
    }
    return 'I am temporarily offline for chat. Ask again in a moment.';
  }
}


